import { createContext } from 'react'
import type { JwtPayload } from '../lib/auth'

export interface AuthContextValue {
  user: JwtPayload | null
  isLoading: boolean
  login: (username: string, password: string) => Promise<void>
  logout: () => void
}

export const AuthContext = createContext<AuthContextValue | null>(null)
